import { GlobalStyles } from '@mui/material';
import { alpha } from '@mui/material/styles';
import React from 'react';

const globalStyles = (
  <GlobalStyles
    styles={(theme) => {
      const { primary, typography } = theme.palette;
      const secondaryMain = theme.palette.secondary.main;
      const secondaryLight = theme.palette.secondary.light || secondaryMain;
      const secondaryDark = theme.palette.secondary.dark || secondaryMain;
      const primaryMain = theme.palette.primary.main;
      const primaryLight = theme.palette.primary.light || primaryMain;
      const primaryDark = theme.palette.primary.dark || primaryMain;
      const backgroundDefault = theme.palette.background.default;
      const backgroundPaper = theme.palette.background.paper;
      const divider = theme.palette.divider;
      const textPrimary = theme.palette.text.primary;
      const textSecondary = theme.palette.text.secondary;
      const surfaceMuted = theme.palette.tertiary?.dark || backgroundDefault;
      const errorMain = theme.palette.error.main;

      return {
        '*, *::before, *::after': {
          boxSizing: 'border-box',
        },
        html: {
          WebkitFontSmoothing: 'antialiased',
          MozOsxFontSmoothing: 'grayscale',
        },
        ':root': {
          '--modern-bg-default': backgroundDefault,
          '--modern-bg-paper': backgroundPaper,
          '--modern-border': divider,
          '--modern-text-primary': textPrimary,
          '--modern-text-secondary': textSecondary,
          '--modern-primary-main': primaryMain,
          '--modern-primary-light': primaryLight,
          '--modern-primary-dark': primaryDark,
          '--modern-secondary-main': secondaryMain,
          '--modern-secondary-light': secondaryLight,
          '--modern-secondary-dark': secondaryDark,
          '--modern-surface-muted': surfaceMuted,
          '--modern-error-main': errorMain,
          '--modern-shadow-soft': `0 24px 44px -32px ${alpha(primaryMain, 0.38)}`,
          '--modern-shadow-card': `0 20px 38px -30px ${alpha(primaryMain, 0.4)}`,
          '--modern-shadow-popover': `0 20px 40px -30px ${alpha(primaryMain, 0.42)}`,
          '--modern-overlay-surface': alpha(backgroundDefault, 0.92),
        },
        body: {
          backgroundColor: backgroundDefault,
          color: textPrimary,
          lineHeight: 1.5,
          margin: 0,
        },
        '#root': {
          minHeight: '100vh',
        },
        '::selection': {
          backgroundColor: theme.palette.secondary.light,
          color: theme.palette.primary.main,
        },
        '.App': {
          minHeight: '100vh',
          background: `radial-gradient(1200px 480px at 100% -10%, ${alpha(secondaryMain, 0.12)}, transparent 60%), linear-gradient(180deg, ${backgroundDefault} 0%, ${alpha(backgroundPaper, 0.98)} 100%)`,
        },
        '.App.browserZoom': {
          overflowX: 'auto',
        },
        'a, button, input, textarea, [role="button"]': {
          transition: 'all 0.2s ease',
        },
        ':focus-visible': {
          outline: `2px solid ${theme.palette.secondary.main}`,
          outlineOffset: '2px',
        },
        '.header-section': {
          height: '0 !important',
          overflow: 'visible !important',
          position: 'static !important',
          boxShadow: 'none !important',
          border: 'none !important',
        },
        '.page_footer': {
          borderTop: `1px solid ${theme.palette.divider}`,
          backgroundColor: theme.palette.background.paper,
        },
        /**
         * Date picker tool.
         */
        '.rs-calendar-table-cell-selected .rs-calendar-table-cell-content': {
          backgroundColor: primary.main,
        },
        '.rs-picker-popup .rs-calendar .rs-calendar-table-cell:hover .rs-calendar-table-cell-content':
          {
            backgroundColor: primary.dark,
          },
        '.rs-calendar-table-cell-in-range:before': {
          backgroundColor: primary.light,
        },
        '.rs-picker-popup .rs-calendar .rs-calendar-table-cell:hover .rs-calendar-table-cell-content, .rs-picker-popup .rs-calendar .rs-calendar-table-cell-content':
          {
            color: typography.main,
          },
        '.rs-btn-primary': {
          backgroundColor: primary.main,
        },
        '.rs-picker-daterange-predefined .rs-btn': {
          color: primary.dark,
        },

        /**
         * MUI Counter (Badge).
         */
        '.MuiBadge-badge': {
          backgroundColor: primary.light,
          color: typography.main,
        },
        '.MuiDataGrid-root .MuiDataGrid-cell:focus': {
          outline: 'none',
        },
        '.MuiDataGrid-root .MuiDataGrid-cell:focus-within': {
          outline: `2px solid ${theme.palette.secondary.main}`,
          outlineOffset: '-2px',
          borderRadius: '6px',
        },
      };
    }}
  />
);

export default globalStyles;
